import { StyleSheet } from "@react-pdf/renderer";
import theme from "../../../../../css/WhiteLabelledDocuments/theme";
import { Font } from "@react-pdf/renderer";
import OpenSansBold from "../../../../../assets/fonts/Open_Sans/OpenSans-Bold.ttf";
import OpenSansRegular from "../../../../../assets/fonts/Open_Sans/OpenSans-Regular.ttf";
import RalewayRegular from "../../../../../assets/fonts/Raleway/Raleway-Regular.ttf";
import RalewayBold from "../../../../../assets/fonts/Raleway/Raleway-Bold.ttf";

Font.register({
  family: "Open Sans",
  fonts: [
    { src: OpenSansBold, fontWeight: "bold" },
    { src: OpenSansRegular, fontWeight: "normal" },
  ],
});

Font.register({
  family: "Raleway",
  fonts: [
    {
      src: RalewayRegular,
      fontWeight: "normal",
    },
    {
      src: RalewayBold,
      fontWeight: "bold",
    },
  ],
});

//  Helper to convert hex to RGB
const hexToRgb = (hex) => {
  const cleanHex = hex.replace("#", "");
  const bigint = parseInt(cleanHex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return { r, g, b };
};

// Helper to calculate brightness
const getTextColor = (hex) => {
  const { r, g, b } = hexToRgb(hex);
  // relative luminance formula
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance > 186 ? "#000000" : "#ffffff"; // threshold
};

const blendWithWhite10 = (hex, opacity = 0.1) => {
  const { r, g, b } = hexToRgb(hex);
  const blended = {
    r: Math.round((1 - opacity) * 255 + opacity * r),
    g: Math.round((1 - opacity) * 255 + opacity * g),
    b: Math.round((1 - opacity) * 255 + opacity * b),
  };
  return `rgb(${blended.r}, ${blended.g}, ${blended.b})`;
};

const blendWithWhite = (hex, opacity = 0.1) => {
  const { r, g, b } = hexToRgb(hex);
  const blended = {
    r: Math.round((1 - opacity) * 255 + opacity * r),
    g: Math.round((1 - opacity) * 255 + opacity * g),
    b: Math.round((1 - opacity) * 255 + opacity * b),
  };
  return `rgb(${blended.r}, ${blended.g}, ${blended.b})`;
};

const DCCReportStyles = (primaryColor) =>
  // const textColor = getTextColor(primaryColor);
  // const highlightBg = blendWithWhite(primaryColor, 0.1);
  // const headerfooterBg = blendWithWhite10(primaryColor, 0.3);

  StyleSheet.create({
    page: {
      padding: 30,
      fontSize: 11,
      gap: 10,
      marginTop: 10,
      marginBottom: 10,
    },
    graphicWrapper: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
    },
    graphicBox: {
      position: "absolute",
      top: "-132%",
      left: "-60%",
      width: "110%",
      height: "250%",
      backgroundColor: blendWithWhite(primaryColor, 0.6),
      transform: "rotate(45deg)",
    },
    graphicBox1: {
      position: "absolute",
      bottom: "60%",
      right: "-130%",
      width: "190%",
      height: "250%",
      backgroundColor: `#${primaryColor}`,
      transform: "rotate(35deg)",
    },
    graphicBox2: {
      position: "absolute",
      bottom: "94.3%",
      right: "-20%",
      width: "200%",
      height: "2%",
      backgroundColor: blendWithWhite10(primaryColor, 0.8),
      transform: "rotate(35deg)",
    },
    graphicBox3: {
      position: "absolute",
      bottom: "92%",
      right: "-20%",
      width: "200%",
      height: "2%",
      backgroundColor: blendWithWhite10(primaryColor, 0.3),
      transform: "rotate(35deg)",
    },
    graphicBox14: {
      position: "absolute",
      top: "-102%",
      left: "-60%",
      width: "110%",
      height: "250%",
      transform: "rotate(45deg)",
      backgroundColor: blendWithWhite10(primaryColor, 0.4),
    },
    graphicBox15: {
      backgroundColor: `#${primaryColor}`,
      position: "absolute",
      bottom: "40%",
      right: "-130%",
      width: "190%",
      height: "250%",
      transform: "rotate(35deg)",
    },
    graphicBox16: {
      backgroundColor: blendWithWhite(primaryColor, 0.8),
      position: "absolute",
      bottom: "73%",
      right: "-20%",
      width: "200%",
      height: "2%",
      transform: "rotate(35deg)",
    },
    graphicBox17: {
      backgroundColor: blendWithWhite10(primaryColor, 0.3),
      position: "absolute",
      bottom: "75.3%",
      right: "-20%",
      width: "200%",
      height: "2%",
      transform: "rotate(35deg)",
    },
    graphicBox4: {
      position: "absolute",
      bottom: "-3%",
      right: "23%",
      width: 50,
      height: 50,
      transform: "rotate(45deg)",
      backgroundColor: `#${primaryColor}`,
    },
    graphicBox5: {
      backgroundColor: blendWithWhite(primaryColor, 0.5),
      position: "absolute",
      bottom: "-2%",
      right: "20%",
      width: 35,
      height: 35,
      transform: "rotate(45deg)",
    },
    graphicBox6: {
      // backgroundColor: blendWithWhite10(primaryColor, 0.3),
      position: "absolute",
      bottom: "0%",
      right: "35%",
      width: 40,
      height: 40,
      border: `2px solid ${blendWithWhite(primaryColor, 0.8)}`,
      transform: "rotate(45deg)",
    },
    graphicBox7: {
      // backgroundColor: blendWithWhite10(primaryColor, 0.4),
      border: `3px solid ${blendWithWhite(primaryColor, 0.6)}`,
      position: "absolute",
      bottom: "-5%",
      right: "3%",
      width: 70,
      height: 70,
      transform: "rotate(45deg)",
    },
    graphicBox8: {
      backgroundColor: blendWithWhite(primaryColor, 0.5),
      position: "absolute",
      bottom: "-3%",
      right: "45%",
      width: 30,
      height: 30,
      transform: "rotate(45deg)",
    },
    graphicBox9: {
      position: "absolute",
      bottom: "-3%",
      right: "23%",
      width: 50,
      height: 50,
      transform: "rotate(45deg)",
      backgroundColor: `#${primaryColor}`,
    },
    graphicBox10: {
      backgroundColor: blendWithWhite(primaryColor, 0.6),
      position: "absolute",
      bottom: "-2%",
      right: "20%",
      width: 35,
      height: 35,
      transform: "rotate(45deg)",
    },
    graphicBox11: {
      // backgroundColor: blendWithWhite10(primaryColor, 0.3),
      position: "absolute",
      bottom: "0%",
      right: "35%",
      width: 40,
      height: 40,
      border: `2px solid ${blendWithWhite(primaryColor, 0.4)}`,
      transform: "rotate(45deg)",
    },
    graphicBox12: {
      // backgroundColor: blendWithWhite10(primaryColor, 0.4),
      border: `3px solid ${blendWithWhite(primaryColor, 0.2)}`,
      position: "absolute",
      bottom: "-5%",
      right: "3%",
      width: 70,
      height: 70,
      transform: "rotate(45deg)",
    },
    graphicBox13: {
      backgroundColor: blendWithWhite(primaryColor, 0.5),
      position: "absolute",
      bottom: "-3%",
      right: "45%",
      width: 30,
      height: 30,
      transform: "rotate(45deg)",
    },
    bubblesWrapper: {
      position: "absolute",
      bottom: 40,
      right: 40,
      width: 320, // match outermost bubble width
      height: 320,
      justifyContent: "center",
      alignItems: "center",
      pointerEvents: "none",
    },

    bubbleOuter: {
      position: "absolute",
      right: -180,
      bottom: 10,
      width: 318,
      height: 318,
      borderRadius: 159,
      backgroundColor: `#${primaryColor}`,
      opacity: 0.11,
    },

    bubbleMiddle: {
      position: "absolute",
      right: 60,
      bottom: 140,
      width: 250,
      height: 250,
      borderRadius: 125,
      backgroundColor: `#${primaryColor}`,
      opacity: 0.11,
    },

    bubbleInner: {
      position: "absolute",
      right: 250,
      bottom: 120,
      width: 120,
      height: 120,
      borderRadius: 60,
      backgroundColor: `#${primaryColor}`,
      opacity: 0.14,
    },
    header: {
      fontFamily: "Open Sans",
      fontSize: 18,
      textAlign: "center",
      fontWeight: "bold",
      letterSpacing: 1,
      color: `#${primaryColor}`,
      alignItems: "center",
      // flexGrow: 1,
    },
    row: {
      flexDirection: "row", // Align items horizontally
      justifyContent: "space-between", // Push content to edges
      alignItems: "center", // Align items vertically in the center
      alignContent: "center",
      marginBottom: 10,
    },
    column: {
      flexDirection: "column", // Align items horizontally
      justifyContent: "center", // Push content to edges
      alignItems: "center", // Align items vertically in the center
      alignContent: "center",
      marginBottom: 10,
    },
    headerContainer: {
      flexDirection: "column",
      justifyContent: "flex-start",

      // alignItems: "center",
      // padding: 20,
    },
    centeredContent: {
      flexDirection: "column",

      justifyContent: "flex-end",
      alignItems: "center",
      textAlign: "center",
      gap: 10,
      height: "100%",
      marginBottom: 150,
    },
    content: {
      marginBottom: 5,
      textAlign: "justify",

      fontSize: 10,
      lineHeight: 1.5,
      fontFamily: "Open Sans",
      wrap: false,
    },
    subcontent: {
      fontFamily: "Open Sans",
      fontWeight: "bold",
      textAlign: "justify",
      fontSize: 10,
      lineHeight: 1.5,
      color: `#${primaryColor}`,
    },

    subheading: {
      fontFamily: "Raleway",
      fontSize: 12,
      letterSpacing: 1,
      marginTop: 5,
      fontWeight: "bold",
      color: `#${primaryColor}`,
      lineHeight: 1.5,
    },
    text: { marginBottom: 5, color: theme.colors.Brand1PenBlue },
    alternateRow: {
      backgroundColor: blendWithWhite(primaryColor, 0.1),
    },
    table: {
      display: "table",
      width: "auto",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: theme.colors.Brand4LavenderWeb,
      marginBottom: 10,
      marginTop: 10,
    },
    tableRow: {
      flexDirection: "row",
      borderBottomStyle: "solid",
      borderBottomWidth: 1,
      borderBottomColor: theme.colors.Brand4LavenderWeb,
      wrap: false,
    },
    tableHeader: {
      backgroundColor: blendWithWhite(primaryColor, 0.9),
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      padding: 5,
      color: theme.colors.White,
      fontFamily: "Raleway",
      fontWeight: "bold",
      fontSize: 10,
    },
    tableCell: {
      padding: 5,
      fontSize: 10,
      flexGrow: 1,
    },
    questionCell: {
      flex: 4, // Wider for question
      padding: 5,
      fontSize: 10,
      borderRightColor: theme.colors.Brand4LavenderWeb,
      borderRightWidth: 1,
    },
    responseCell: {
      flex: 1, // Narrower for response
      padding: 5,
      fontSize: 10,
    },
    riskCell: {
      flex: 1,
      padding: 5,
      fontSize: 10,
      borderRightColor: theme.colors.Brand4LavenderWeb,
      borderRightWidth: 1,
    },
    descriptionCell: {
      flex: 3,
      padding: 5,
      fontSize: 10,
      wrap: false,
      minHeight: 50,
    },
    image: {
      maxWidth: 275,
      maxHeight: 215,
    },
    pageWithChrome: {
      paddingLeft: 30,
      paddingRight: 30,
      paddingTop: 40,
      paddingBottom: 50,
    },
    pageHeader: {
      position: "absolute",
      top: 20,
      left: 30,
      right: 30,
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      // backgroundColor: `#${primaryColor}`,
    },
    pageHeaderText: {
      fontSize: 8,
      fontFamily: "Open Sans",
      color: blendWithWhite(primaryColor, 0.6),
    },
    footer: {
      position: "absolute",
      bottom: 20,
      left: 30,
      right: 30,
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      fontSize: 10,
    },
    pageFooterText: {
      fontSize: 6,
      fontFamily: "Open Sans",
      textAlign: "center",
      color: blendWithWhite(primaryColor, 0.6),
    },
    verticalBox: {
      height: 5,
    }
  });

export default DCCReportStyles;
